export default __webpack_public_path__ + "static/cruiselines-vv-activities-4-31e539f87ddb1a09f22362e1172f20e6.jpg";